import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faMapMarkerAlt,
  faEnvelope,
  faPhone,
} from '@fortawesome/free-solid-svg-icons';
import {
  faInstagram,
  faFacebook,
  faTwitter,
  faPinterest,
} from '@fortawesome/free-brands-svg-icons';

const Footer = () => {
  return (
    <footer id="contact" className="bg-dark text-white py-16 pb-8">
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap justify-between gap-8 mb-16 md:flex-row flex-col">
          {/* Logo Section */}
          <div className="flex-1 min-w-[200px] md:mb-0 mb-8">
            <h2 className="text-white text-3xl font-heading mb-4">
              Curators' Studio
            </h2>
            <p>Premium flower subscriptions for discerning homes.</p>
          </div>

          {/* Quick Links */}
          <div className="flex-1 min-w-[200px] md:mb-0 mb-8">
            <h3 className="text-secondary text-xl mb-6 relative pb-2 after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-10 after:h-0.5 after:bg-secondary">
              Quick Links
            </h3>
            <ul>
              <li className="mb-2">
                <Link
                  to="/"
                  className="text-white opacity-80 hover:opacity-100 hover:text-secondary transition-colors duration-300"
                >
                  Home
                </Link>
              </li>
              <li className="mb-2">
                <Link
                  to="/#about"
                  className="text-white opacity-80 hover:opacity-100 hover:text-secondary transition-colors duration-300"
                >
                  About
                </Link>
              </li>
              <li className="mb-2">
                <Link
                  to="/#features"
                  className="text-white opacity-80 hover:opacity-100 hover:text-secondary transition-colors duration-300"
                >
                  Features
                </Link>
              </li>
              <li className="mb-2">
                <Link
                  to="/contact"
                  className="text-white opacity-80 hover:opacity-100 hover:text-secondary transition-colors duration-300"
                >
                  Contact
                </Link>
              </li>
              <li className="mb-2">
                <Link
                  to="/subscribe"
                  className="text-white opacity-80 hover:opacity-100 hover:text-secondary transition-colors duration-300"
                >
                  Subscribe
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="flex-1 min-w-[200px] md:mb-0 mb-8">
            <h3 className="text-secondary text-xl mb-6 relative pb-2 after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-10 after:h-0.5 after:bg-secondary">
              Contact Us
            </h3>
            <p className="mb-2 flex items-center">
              <FontAwesomeIcon
                icon={faMapMarkerAlt}
                className="mr-2.5 text-secondary"
              />{' '}
              Gurugram, Haryana, India
            </p>
            <p className="mb-2 flex items-center">
              <FontAwesomeIcon
                icon={faEnvelope}
                className="mr-2.5 text-secondary"
              />{' '}
              hello@curators.studio
            </p>
            <p className="mb-2 flex items-center">
              <FontAwesomeIcon
                icon={faPhone}
                className="mr-2.5 text-secondary"
              />{' '}
              +91 9008789490
            </p>
          </div>

          {/* Social Media */}
          <div className="flex-1 min-w-[200px]">
            <h3 className="text-secondary text-xl mb-6 relative pb-2 after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-10 after:h-0.5 after:bg-secondary">
              Follow Us
            </h3>
            <div className="flex gap-4">
              <a
                href="#"
                className="flex items-center justify-center w-10 h-10 rounded-full bg-white/10 text-white transition-all duration-300 hover:bg-secondary hover:text-dark hover:-translate-y-0.5"
              >
                <FontAwesomeIcon icon={faInstagram} />
              </a>
              <a
                href="#"
                className="flex items-center justify-center w-10 h-10 rounded-full bg-white/10 text-white transition-all duration-300 hover:bg-secondary hover:text-dark hover:-translate-y-0.5"
              >
                <FontAwesomeIcon icon={faFacebook} />
              </a>
              <a
                href="#"
                className="flex items-center justify-center w-10 h-10 rounded-full bg-white/10 text-white transition-all duration-300 hover:bg-secondary hover:text-dark hover:-translate-y-0.5"
              >
                <FontAwesomeIcon icon={faTwitter} />
              </a>
              <a
                href="#"
                className="flex items-center justify-center w-10 h-10 rounded-full bg-white/10 text-white transition-all duration-300 hover:bg-secondary hover:text-dark hover:-translate-y-0.5"
              >
                <FontAwesomeIcon icon={faPinterest} />
              </a>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="border-t border-white/10 pt-8 flex justify-between flex-wrap gap-4 sm:flex-row sm:text-left text-center flex-col">
          <p className="opacity-70 mb-0">
            &copy; {new Date().getFullYear()} Curators' Studio. All rights
            reserved.
          </p>
          <div className="flex gap-8 sm:justify-start justify-center flex-wrap">
            <Link
              to="/shipping-delivery"
              className="text-white opacity-70 hover:opacity-100 hover:text-secondary transition-colors duration-300"
            >
              Shipping and Delivery
            </Link>
            <Link
              to="/privacy-policy"
              className="text-white opacity-70 hover:opacity-100 hover:text-secondary transition-colors duration-300"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms-conditions"
              className="text-white opacity-70 hover:opacity-100 hover:text-secondary transition-colors duration-300"
            >
              Terms and Conditions
            </Link>
            <Link
              to="/cancellation-refund"
              className="text-white opacity-70 hover:opacity-100 hover:text-secondary transition-colors duration-300"
            >
              Cancellation and Refund
            </Link>
            <Link
              to="/contact"
              className="text-white opacity-70 hover:opacity-100 hover:text-secondary transition-colors duration-300"
            >
              Contact Us
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
